import { ToWords } from "to-words/en-IN";
import type { ReceiptLineItem } from "@/components/common-receipt/CommonReceiptA5";
import {
  defaultA5ChromeProps,
  onlineOrPlainPaymentText,
} from "@/components/common-receipt/a5-print-defaults";

const toWords = new ToWords();

export type YearlyNiyaazReceiptPrintRecord = {
  id?: string | number;
  receiptNo?: string;
  receiptDate?: string;
  amount?: number;
  paymentMode?: string;
  paymentRef?: string | null;
  remarks?: string;
  createdBy?: string;
  yearlyNiyaaz?: {
    formNo?: string;
    name?: string;
    itsNo?: string;
    hijriYear?: string;
  };
};

export function yearlyNiyaazReceiptPaymentText(data: YearlyNiyaazReceiptPrintRecord): string {
  return onlineOrPlainPaymentText(data.paymentMode, data.paymentRef);
}

export function yearlyNiyaazReceiptLines(data: YearlyNiyaazReceiptPrintRecord): ReceiptLineItem[] {
  const niyaaz = data.yearlyNiyaaz;
  const paymentText = yearlyNiyaazReceiptPaymentText(data);
  return [
    {
      left: "Received from",
      right: `${niyaaz?.name || ""} ${niyaaz?.itsNo ? `(ITS - ${niyaaz.itsNo})` : ""}`,
      bold: true,
    },
    {
      left: "Form No / Hijri Year",
      right: `${niyaaz?.formNo || "-"} / ${niyaaz?.hijriYear || "-"}`,
    },
    {
      left: "The sum of Rupees",
      right: `${toWords.convert(Number(data.amount) || 0)} Only`,
      bold: true,
    },
    {
      left: "Received by / Towards",
      right: `${paymentText} towards Yearly Niyaaz`,
    },
    ...(data.remarks ? [{ left: "Remarks", right: String(data.remarks) }] : []),
  ];
}

export function yearlyNiyaazReceiptA5Props(data: YearlyNiyaazReceiptPrintRecord) {
  return {
    ...defaultA5ChromeProps(),
    subTitle: "Yearly Niyaaz Receipt",
    receiptNo: data.receiptNo,
    date: data.receiptDate,
    receiptLines: yearlyNiyaazReceiptLines(data),
    amount: Number(data.amount),
    digitalSignatureValue: `${data.id}|${data.createdBy}`,
  };
}
